import React from 'react';
import ButtonContent, { ButtonPresetModel } from './button.content';

type ButtonType = 'large' | 'medium' | 'small';

interface ButtonProps {
  text: string;
  handleOnClick: () => void;
  type?: ButtonType;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ButtonPresetConfig<T extends keyof any> = {
  [K in T]: ButtonPresetModel;
};

const Button: React.FunctionComponent<ButtonProps> = ({
  text,
  handleOnClick,
  type = 'medium'
}) => {
  const config: ButtonPresetConfig<ButtonType> = {
    large: {
      fontSize: 'BUTTON_L',
      height: 50,
      borderRadius: 25,
      padding: 16,
      margin: 8
    },
    medium: {
      fontSize: 'BUTTON_M',
      height: 40,
      borderRadius: 20,
      padding: 12,
      margin: 6
    },
    small: {
      fontSize: 'BUTTON_S',
      height: 30,
      borderRadius: 15,
      padding: 10,
      margin: 4
    }
  };

  return (
    <ButtonContent
      handleOnClick={handleOnClick}
      text={text}
      config={config[type]}
    />
  );
};

export default Button;
